export default "__VITE_ASSET__CPsqb7HN__"